export default __webpack_public_path__ + "static/media/drum.e3e51059.png";